import { motion } from 'framer-motion';
import { Heart, Shield, Clock, Users, Stethoscope, Activity } from 'lucide-react';

const Marquee = () => {
  const items = [
    { icon: Heart, text: 'Family Health Management' },
    { icon: Shield, text: 'Trusted by Doctors' },
    { icon: Clock, text: '24/7 Care Access' },
    { icon: Users, text: 'Multi-Generation Support' },
    { icon: Stethoscope, text: 'Expert Medical Team' },
    { icon: Activity, text: 'Health Tracking' },
  ];

  return (
    <div className="relative overflow-hidden bg-slate-900 py-8 border-y border-slate-800">
      <motion.div
        className="flex gap-16 whitespace-nowrap"
        animate={{
          x: [0, -1920]
        }}
        transition={{
          x: {
            duration: 30,
            repeat: Infinity,
            ease: "linear"
          }
        }}
      >
        {[...items, ...items, ...items, ...items].map((item, index) => (
          <div key={index} className="flex items-center gap-3">
            <item.icon className="h-6 w-6 text-teal-400" />
            <span className="text-xl font-medium text-white">{item.text}</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default Marquee;